module.exports = __webpack_public_path__ + "media/images/gift/gift-main-image-4f45782aec0ee2abdc796eb56d11b1c6.png";